(() => {

    document.addEventListener('DOMContentLoaded', () => {

        document
            .querySelectorAll('.device-step-1__quantity')
            .forEach(quantity => {

                const minus = quantity.querySelector('.device-step-1__minus');
                const plus = quantity.querySelector('.device-step-1__plus');
                const value = quantity.querySelector('[data-value]');
                const input = quantity.querySelector('[data-input]');

                let current = parseInt(input.value || 0, 10);

                const update = () => {

                    value.textContent = current;

                    input.value = current;

                    input.dispatchEvent(
                        new Event('input', {
                            bubbles: true
                        })
                    );

                };

                plus.addEventListener('click', () => {

                    current++;

                    update();

                });

                minus.addEventListener('click', () => {

                    if (current === 0) return;

                    current--;

                    update();

                });

                update();

            });
            const addToCartButton = document.getElementById("device-booking-add-to-cart");

                if (addToCartButton) {

                    addToCartButton.addEventListener("click", async () => {

                        const variantId = document.getElementById("device-booking-variant-id").value;

                        const bookingProperties = {};

                        // Step 1 - Device Quantities
                        document
                            .querySelectorAll(".device-step-1__quantity")
                            .forEach(quantity => {

                                const device = quantity.dataset.device;
                                const input = quantity.querySelector("[data-input]");

                                bookingProperties[device] = input.value;

                            });

                        // Step 2, 3 & 4
                        document
                            .querySelectorAll('[name^="properties["]')
                            .forEach(field => {

                                // Skip Step 1 quantity inputs
                                if (field.hasAttribute("data-input")) {
                                    return;
                                }

                                // Only include the selected radio button
                                if (field.type === "radio" && !field.checked) {
                                    return;
                                }

                                const match = field.name.match(/^properties\[(.+)\]$/);

                                if (!match) {
                                    return;
                                }

                                bookingProperties[match[1]] = field.value;

                            });

                        try {

                            const bookingAddress = {
                                fullName: bookingProperties["Full Name"] || "",
                                phone: bookingProperties["Phone Number"] || "",
                                property: bookingProperties["Property Type"] || "",
                                address: bookingProperties["Collection Address"] || "",
                                postalCode: bookingProperties["Postal Code"] || "",
                                unitNumber: bookingProperties["Unit Number"] || ""
                            };

                            await ExXtraAddToCart.add({
                                variantId,
                                quantity: 1,
                                properties: bookingProperties,
                                address: bookingAddress,
                                redirect: true
                            });

                        } catch (error) {

                            console.error(error);

                            alert("Unable to add booking to cart. Please try again.");

                        }

                    });

                }

    });

    
})();